module.exports = __webpack_public_path__ + "assets/img/zs-banner.7f487534.png";